<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-alert dense type="error" outlined text dismissible transition="slide-x-transition"
          class="py-0 text-uppercase" v-for="(item, index) in mxUpdateUserErrors" :key="index">
          {{ item[0] }}
        </v-alert>
        <v-text-field outlined dense hide-details="auto" v-model="username" label="Username"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-autocomplete dense outlined hide-details="auto" item-value="routeName" item-text="alias"
          :items="getHomepageList()" v-model="homepage" label="Homepage"></v-autocomplete>
      </v-col>
      <v-col cols="12">
        <v-text-field outlined dense hide-details="auto" v-model="name" label="Name"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field outlined dense hide-details="auto" v-model="email" label="Email"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-switch v-model="active" label="Active"></v-switch>
      </v-col>
      <v-col cols="12">
        <v-btn dark color="primary" @click="initUpdate" :loading="mxUpdatingUser">Save</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { routeNames } from '../../../../../../router'
import { updateUser } from './../../../../mixins/users.mixin'
export default {
  name: 'vEditUser',
  props: {
    propUserId: Number,
    propUserData: Object,
  },
  data() {
    return {
      username: null,
      name: null,
      email: null,
      homepage: null,
      active: 0,
    }
  },
  watch: {
    propUserId() {
      this.username = this.propUserData.username
      this.name = this.propUserData.name
      this.email = this.propUserData.email
      this.active = this.propUserData.active
      this.homepage = this.propUserData.homepage
    },
  },
  methods: {
    getHomepageList() {
      return routeNames
    },
    initUpdate() {
      this.mxUpdateUser(this.propUserId, {
        username: this.username,
        name: this.name,
        email: this.email,
        homepage: this.homepage,
        active: this.active,
      }, () => {
        this.$emit('saved')
        this.$emit('close-dialog')
      })
    },
  },
  mixins: [
    updateUser,
  ],
}
</script>
